module.exports = __webpack_public_path__ + "img/ai-chat-history-delete.30eb3a31.svg";